import * as Sentry from "@sentry/react";

/**
 * Dashboard Sentry init (TEA-37).
 *
 * Inert when `VITE_SENTRY_DSN` is unset so local dev / preview builds
 * don't ship errors. Release is tagged with the Cloudflare commit SHA
 * when the Worker build injects one.
 */
export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return false;
  Sentry.init({
    dsn,
    release: import.meta.env.VITE_RELEASE_SHA ?? undefined,
    environment: import.meta.env.MODE ?? "production",
    tracesSampleRate: 0,
    integrations: [Sentry.browserTracingIntegration()],
  });
  return true;
}

/**
 * Record an ApiError as a Sentry exception with the route + code as tags.
 * Called from api.js so any 5xx-class API failure surfaces in Sentry with
 * enough context to triage without leaving the dashboard.
 */
export function captureApiError(err, { path, method }) {
  Sentry.withScope((scope) => {
    if (path) scope.setTag("route", path);
    if (method) scope.setTag("method", method);
    if (err?.code) scope.setTag("api_code", err.code);
    if (typeof err?.status === "number") scope.setTag("api_status", String(err.status));
    Sentry.captureException(err);
  });
}

export { Sentry };
